// extracted by mini-css-extract-plugin
module.exports = {"arrow":"ku","dropMenu":"kv","dropMenuInner":"kw","itemborder":"kx","dropDownCurrent":"ky","menuItem":"kz","langContainer":"kA","current":"kB","outlink":"kC"};